import React from 'react';
import { Panel } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import PropTypes from 'prop-types';
import './successMessageDialog.scss';

export const SuccessMessageDialog = ({
  message,
  onClose = () => {}, // default is empty function
  closeButtonLabel = 'Close'
}) => {
  return (
    <div>
      <Panel
        type="modal"
        open
        size="tiny"
        customCssClass="successMessageDialog"
        footer={{
          fixed: true,
          content: (
            <button
              type="button"
              className="button primary outline"
              onClick={onClose}
            >
              <span className="labelText">{closeButtonLabel}</span>
            </button>
          )
        }}
        onClose={onClose}
      >
        <section className="message">
          <p>{message}</p>
        </section>
      </Panel>
    </div>
  );
};

SuccessMessageDialog.propTypes = {
  message: PropTypes.string,
  onClose: PropTypes.func,
  closeButtonLabel: PropTypes.string
};
